import React from "react";
import Card from "./doctorCard";
import doctor1 from "../../../images/doctor.png";
import doctor2 from "../../../images/doctor2.png";
import doctor3 from "../../../images/doctor3.png";
import doctor4 from "../../../images/doctor4.png";

const DoctorList = () => {
  const cards = [
    {
      img: doctor1,
      name: "Colin Bastick",
      days: [
        {
          morning: [
            { time: "10:30 AM", isAvailable: true },
            { time: "11:00 AM", isAvailable: false },
            { time: "11:30 AM", isAvailable: true },
          ],
          afternoon: [
            { time: "10:30 AM", isAvailable: true },
            { time: "1:00 AM", isAvailable: false },
            { time: "2:30 AM", isAvailable: true },
          ],
          // evening: [
          //   { time: "6:30 AM", isAvailable: true },
          //   { time: "7:00 AM", isAvailable: false },
          //   { time: "8:30 AM", isAvailable: true },
          // ],
        },
        {
          morning: [
            { time: "10:30 AM", isAvailable: true },
            { time: "11:00 AM", isAvailable: false },
            { time: "11:30 AM", isAvailable: true },
          ],
          // afternoon: [
          //   { time: "10:30 AM", isAvailable: true },
          //   { time: "1:00 AM", isAvailable: false },
          //   { time: "2:30 AM", isAvailable: true },
          // ],
          evening: [
            { time: "6:30 AM", isAvailable: true },
            { time: "7:00 AM", isAvailable: false },
            { time: "8:30 AM", isAvailable: true },
          ],
        },
        {
          morning: [
            { time: "10:30 AM", isAvailable: true },
            { time: "11:00 AM", isAvailable: false },
            { time: "11:30 AM", isAvailable: true },
          ],
          afternoon: [
            { time: "10:30 AM", isAvailable: true },
            { time: "1:00 AM", isAvailable: false },
            { time: "2:30 AM", isAvailable: true },
          ],
          evening: [
            { time: "6:30 AM", isAvailable: false },
            { time: "7:00 AM", isAvailable: false },
            { time: "8:30 AM", isAvailable: true },
          ],
        },
        {
          morning: [
            { time: "10:30 AM", isAvailable: true },
            { time: "11:00 AM", isAvailable: false },
            { time: "11:30 AM", isAvailable: true },
          ],
          afternoon: [
            { time: "10:30 AM", isAvailable: true },
            { time: "1:00 AM", isAvailable: false },
            { time: "2:30 AM", isAvailable: true },
          ],
          evening: [
            { time: "6:30 AM", isAvailable: false },
            { time: "7:00 AM", isAvailable: false },
            { time: "8:30 AM", isAvailable: true },
          ],
        },
        {
          // morning: [
          //   { time: "10:30 AM", isAvailable: true },
          //   { time: "11:00 AM", isAvailable: false },
          //   { time: "11:30 AM", isAvailable: true },
          // ],
          afternoon: [
            { time: "10:30 AM", isAvailable: true },
            { time: "1:00 AM", isAvailable: false },
            { time: "2:30 AM", isAvailable: true },
          ],
          evening: [
            { time: "6:30 AM", isAvailable: false },
            { time: "7:00 AM", isAvailable: false },
            { time: "8:30 AM", isAvailable: true },
          ],
        },
        {
          morning: [
            { time: "10:30 AM", isAvailable: true },
            { time: "11:00 AM", isAvailable: false },
            { time: "11:30 AM", isAvailable: true },
          ],
          // afternoon: [
          //   { time: "10:30 AM", isAvailable: true },
          //   { time: "1:00 AM", isAvailable: false },
          //   { time: "2:30 AM", isAvailable: true },
          // ],
          evening: [
            { time: "6:30 AM", isAvailable: false },
            { time: "7:00 AM", isAvailable: false },
            { time: "8:30 AM", isAvailable: true },
          ],
        },
        {
          morning: [
            { time: "10:30 AM", isAvailable: true },
            { time: "11:00 AM", isAvailable: false },
            { time: "11:30 AM", isAvailable: true },
          ],
          // afternoon: [
          //   { time: "10:30 AM", isAvailable: true },
          //   { time: "1:00 AM", isAvailable: false },
          //   { time: "2:30 AM", isAvailable: true },
          // ],
          evening: [
            { time: "6:30 AM", isAvailable: false },
            { time: "7:00 AM", isAvailable: false },
            { time: "8:30 AM", isAvailable: true },
          ],
        },
        {
          morning: [
            { time: "10:30 AM", isAvailable: true },
            { time: "11:00 AM", isAvailable: false },
            { time: "11:30 AM", isAvailable: true },
          ],
          afternoon: [
            { time: "10:30 AM", isAvailable: true },
            { time: "1:00 AM", isAvailable: false },
            { time: "2:30 AM", isAvailable: true },
          ],
          evening: [
            { time: "6:30 AM", isAvailable: false },
            { time: "7:00 AM", isAvailable: false },
            { time: "8:30 AM", isAvailable: true },
          ],
        },
        {
          // morning: [
          //   { time: "10:30 AM", isAvailable: true },
          //   { time: "11:00 AM", isAvailable: false },
          //   { time: "11:30 AM", isAvailable: true },
          // ],
          afternoon: [
            { time: "10:30 AM", isAvailable: true },
            { time: "1:00 AM", isAvailable: false },
            { time: "2:30 AM", isAvailable: true },
          ],
          evening: [
            { time: "6:30 AM", isAvailable: false },
            { time: "7:00 AM", isAvailable: false },
            { time: "8:30 AM", isAvailable: true },
          ],
        },
        {
          morning: [
            { time: "10:30 AM", isAvailable: true },
            { time: "11:00 AM", isAvailable: false },
            { time: "11:30 AM", isAvailable: true },
          ],
          afternoon: [
            { time: "10:30 AM", isAvailable: true },
            { time: "1:00 AM", isAvailable: false },
            { time: "2:30 AM", isAvailable: true },
          ],
          evening: [
            { time: "6:30 AM", isAvailable: false },
            { time: "7:00 AM", isAvailable: false },
            { time: "8:30 AM", isAvailable: true },
          ],
        },
        {
          morning: [
            { time: "10:30 AM", isAvailable: true },
            { time: "11:00 AM", isAvailable: false },
            { time: "11:30 AM", isAvailable: true },
          ],
          afternoon: [
            { time: "10:30 AM", isAvailable: true },
            { time: "1:00 AM", isAvailable: false },
            { time: "2:30 AM", isAvailable: true },
          ],
          evening: [
            { time: "6:30 AM", isAvailable: false },
            { time: "7:00 AM", isAvailable: false },
            { time: "8:30 AM", isAvailable: true },
          ],
        },
      ],
    },
    {
      img: doctor2,
      name: "Alex Blackburn",
      days: [
        {
          morning: [
            { time: "10:30 AM", isAvailable: true },
            { time: "11:00 AM", isAvailable: false },
            { time: "11:30 AM", isAvailable: true },
          ],
          afternoon: [
            { time: "10:30 AM", isAvailable: true },
            { time: "1:00 AM", isAvailable: false },
            { time: "2:30 AM", isAvailable: true },
          ],
          evening: [
            { time: "6:30 AM", isAvailable: false },
            { time: "7:00 AM", isAvailable: false },
            { time: "8:30 AM", isAvailable: true },
          ],
        },
        {
          morning: [
            { time: "10:30 AM", isAvailable: true },
            { time: "11:00 AM", isAvailable: false },
            { time: "11:30 AM", isAvailable: true },
          ],
          afternoon: [
            { time: "10:30 AM", isAvailable: true },
            { time: "1:00 AM", isAvailable: false },
            { time: "2:30 AM", isAvailable: true },
          ],
          evening: [
            { time: "6:30 AM", isAvailable: false },
            { time: "7:00 AM", isAvailable: false },
            { time: "8:30 AM", isAvailable: true },
          ],
        },
        {
          morning: [
            { time: "10:30 AM", isAvailable: true },
            { time: "11:00 AM", isAvailable: false },
            { time: "11:30 AM", isAvailable: true },
          ],
          afternoon: [
            { time: "10:30 AM", isAvailable: true },
            { time: "1:00 AM", isAvailable: false },
            { time: "2:30 AM", isAvailable: true },
          ],
          evening: [
            { time: "6:30 AM", isAvailable: false },
            { time: "7:00 AM", isAvailable: false },
            { time: "8:30 AM", isAvailable: true },
          ],
        },
        {
          morning: [
            { time: "10:30 AM", isAvailable: true },
            { time: "11:00 AM", isAvailable: false },
            { time: "11:30 AM", isAvailable: true },
          ],
          afternoon: [
            { time: "10:30 AM", isAvailable: true },
            { time: "1:00 AM", isAvailable: false },
            { time: "2:30 AM", isAvailable: true },
          ],
          evening: [
            { time: "6:30 AM", isAvailable: false },
            { time: "7:00 AM", isAvailable: false },
            { time: "8:30 AM", isAvailable: true },
          ],
        },
        {
          morning: [
            { time: "10:30 AM", isAvailable: true },
            { time: "11:00 AM", isAvailable: false },
            { time: "11:30 AM", isAvailable: true },
          ],
          afternoon: [
            { time: "10:30 AM", isAvailable: true },
            { time: "1:00 AM", isAvailable: false },
            { time: "2:30 AM", isAvailable: true },
          ],
          evening: [
            { time: "6:30 AM", isAvailable: false },
            { time: "7:00 AM", isAvailable: false },
            { time: "8:30 AM", isAvailable: true },
          ],
        },
        {
          morning: [
            { time: "10:30 AM", isAvailable: true },
            { time: "11:00 AM", isAvailable: false },
            { time: "11:30 AM", isAvailable: true },
          ],
          afternoon: [
            { time: "10:30 AM", isAvailable: true },
            { time: "1:00 AM", isAvailable: false },
            { time: "2:30 AM", isAvailable: true },
          ],
          evening: [
            { time: "6:30 AM", isAvailable: false },
            { time: "7:00 AM", isAvailable: false },
            { time: "8:30 AM", isAvailable: true },
          ],
        },
        {
          morning: [
            { time: "10:30 AM", isAvailable: true },
            { time: "11:00 AM", isAvailable: false },
            { time: "11:30 AM", isAvailable: true },
          ],
          afternoon: [
            { time: "10:30 AM", isAvailable: true },
            { time: "1:00 AM", isAvailable: false },
            { time: "2:30 AM", isAvailable: true },
          ],
          evening: [
            { time: "6:30 AM", isAvailable: false },
            { time: "7:00 AM", isAvailable: false },
            { time: "8:30 AM", isAvailable: true },
          ],
        },
        {
          morning: [
            { time: "10:30 AM", isAvailable: true },
            { time: "11:00 AM", isAvailable: false },
            { time: "11:30 AM", isAvailable: true },
          ],
          afternoon: [
            { time: "10:30 AM", isAvailable: true },
            { time: "1:00 AM", isAvailable: false },
            { time: "2:30 AM", isAvailable: true },
          ],
          evening: [
            { time: "6:30 AM", isAvailable: false },
            { time: "7:00 AM", isAvailable: false },
            { time: "8:30 AM", isAvailable: true },
          ],
        },
        {
          morning: [
            { time: "10:30 AM", isAvailable: true },
            { time: "11:00 AM", isAvailable: false },
            { time: "11:30 AM", isAvailable: true },
          ],
          afternoon: [
            { time: "10:30 AM", isAvailable: true },
            { time: "1:00 AM", isAvailable: false },
            { time: "2:30 AM", isAvailable: true },
          ],
          evening: [
            { time: "6:30 AM", isAvailable: false },
            { time: "7:00 AM", isAvailable: false },
            { time: "8:30 AM", isAvailable: true },
          ],
        },
      ],
    },
    {
      img: doctor3,
      name: "Richard Chapman",
      days: [
        {
          morning: [
            { time: "10:30 AM", isAvailable: true },
            { time: "11:00 AM", isAvailable: false },
            { time: "11:30 AM", isAvailable: true },
          ],
          afternoon: [
            { time: "10:30 AM", isAvailable: true },
            { time: "1:00 AM", isAvailable: false },
            { time: "2:30 AM", isAvailable: true },
          ],
          evening: [
            { time: "6:30 AM", isAvailable: false },
            { time: "7:00 AM", isAvailable: false },
            { time: "8:30 AM", isAvailable: true },
          ],
        },
        {
          morning: [
            { time: "10:30 AM", isAvailable: true },
            { time: "11:00 AM", isAvailable: false },
            { time: "11:30 AM", isAvailable: true },
          ],
          afternoon: [
            { time: "10:30 AM", isAvailable: true },
            { time: "1:00 AM", isAvailable: false },
            { time: "2:30 AM", isAvailable: true },
          ],
          evening: [
            { time: "6:30 AM", isAvailable: false },
            { time: "7:00 AM", isAvailable: false },
            { time: "8:30 AM", isAvailable: true },
          ],
        },
        {
          morning: [
            { time: "10:30 AM", isAvailable: true },
            { time: "11:00 AM", isAvailable: false },
            { time: "11:30 AM", isAvailable: true },
          ],
          afternoon: [
            { time: "10:30 AM", isAvailable: true },
            { time: "1:00 AM", isAvailable: false },
            { time: "2:30 AM", isAvailable: true },
          ],
          evening: [
            { time: "6:30 AM", isAvailable: false },
            { time: "7:00 AM", isAvailable: false },
            { time: "8:30 AM", isAvailable: true },
          ],
        },
        {
          morning: [
            { time: "10:30 AM", isAvailable: true },
            { time: "11:00 AM", isAvailable: false },
            { time: "11:30 AM", isAvailable: true },
          ],
          afternoon: [
            { time: "10:30 AM", isAvailable: true },
            { time: "1:00 AM", isAvailable: false },
            { time: "2:30 AM", isAvailable: true },
          ],
          evening: [
            { time: "6:30 AM", isAvailable: false },
            { time: "7:00 AM", isAvailable: false },
            { time: "8:30 AM", isAvailable: true },
          ],
        },
        {
          morning: [
            { time: "10:30 AM", isAvailable: true },
            { time: "11:00 AM", isAvailable: false },
            { time: "11:30 AM", isAvailable: true },
          ],
          afternoon: [
            { time: "10:30 AM", isAvailable: true },
            { time: "1:00 AM", isAvailable: false },
            { time: "2:30 AM", isAvailable: true },
          ],
          evening: [
            { time: "6:30 AM", isAvailable: false },
            { time: "7:00 AM", isAvailable: false },
            { time: "8:30 AM", isAvailable: true },
          ],
        },
        {
          morning: [
            { time: "10:30 AM", isAvailable: true },
            { time: "11:00 AM", isAvailable: false },
            { time: "11:30 AM", isAvailable: true },
          ],
          afternoon: [
            { time: "10:30 AM", isAvailable: true },
            { time: "1:00 AM", isAvailable: false },
            { time: "2:30 AM", isAvailable: true },
          ],
          evening: [
            { time: "6:30 AM", isAvailable: false },
            { time: "7:00 AM", isAvailable: false },
            { time: "8:30 AM", isAvailable: true },
          ],
        },
        {
          morning: [
            { time: "10:30 AM", isAvailable: true },
            { time: "11:00 AM", isAvailable: false },
            { time: "11:30 AM", isAvailable: true },
          ],
          afternoon: [
            { time: "10:30 AM", isAvailable: true },
            { time: "1:00 AM", isAvailable: false },
            { time: "2:30 AM", isAvailable: true },
          ],
          evening: [
            { time: "6:30 AM", isAvailable: false },
            { time: "7:00 AM", isAvailable: false },
            { time: "8:30 AM", isAvailable: true },
          ],
        },
        {
          morning: [
            { time: "10:30 AM", isAvailable: true },
            { time: "11:00 AM", isAvailable: false },
            { time: "11:30 AM", isAvailable: true },
          ],
          afternoon: [
            { time: "10:30 AM", isAvailable: true },
            { time: "1:00 AM", isAvailable: false },
            { time: "2:30 AM", isAvailable: true },
          ],
          evening: [
            { time: "6:30 AM", isAvailable: false },
            { time: "7:00 AM", isAvailable: false },
            { time: "8:30 AM", isAvailable: true },
          ],
        },
        {
          morning: [
            { time: "10:30 AM", isAvailable: true },
            { time: "11:00 AM", isAvailable: false },
            { time: "11:30 AM", isAvailable: true },
          ],
          afternoon: [
            { time: "10:30 AM", isAvailable: true },
            { time: "1:00 AM", isAvailable: false },
            { time: "2:30 AM", isAvailable: true },
          ],
          evening: [
            { time: "6:30 AM", isAvailable: false },
            { time: "7:00 AM", isAvailable: false },
            { time: "8:30 AM", isAvailable: true },
          ],
        },
      ],
    },
    {
      img: doctor4,
      name: "John Clark",
      days: [
        {
          morning: [
            { time: "10:30 AM", isAvailable: true },
            { time: "11:00 AM", isAvailable: false },
            { time: "11:30 AM", isAvailable: true },
          ],
          afternoon: [
            { time: "10:30 AM", isAvailable: true },
            { time: "1:00 AM", isAvailable: false },
            { time: "2:30 AM", isAvailable: true },
          ],
          evening: [
            { time: "6:30 AM", isAvailable: false },
            { time: "7:30 AM", isAvailable: false },
            { time: "8:00 AM", isAvailable: false },
            { time: "11:30 AM", isAvailable: true },
          ],
        },
      ],
    },
    {
      img: doctor1,
      name: "Peter Davidson",
      days: [
        {
          morning: [
            { time: "10:30 AM", isAvailable: true },
            { time: "11:00 AM", isAvailable: false },
            { time: "11:30 AM", isAvailable: true },
          ],
          afternoon: [
            { time: "10:30 AM", isAvailable: true },
            { time: "1:00 AM", isAvailable: false },
            { time: "2:30 AM", isAvailable: true },
          ],
          evening: [
            { time: "6:30 AM", isAvailable: false },
            { time: "7:00 AM", isAvailable: false },
            { time: "8:30 AM", isAvailable: true },
          ],
        },
        {
          morning: [
            { time: "10:30 AM", isAvailable: true },
            { time: "11:00 AM", isAvailable: false },
            { time: "11:30 AM", isAvailable: true },
          ],
          afternoon: [
            { time: "10:30 AM", isAvailable: true },
            { time: "1:00 AM", isAvailable: false },
            { time: "2:30 AM", isAvailable: true },
          ],
          evening: [
            { time: "6:30 AM", isAvailable: false },
            { time: "7:00 AM", isAvailable: false },
            { time: "8:30 AM", isAvailable: true },
          ],
        },
        {
          morning: [
            { time: "10:30 AM", isAvailable: true },
            { time: "11:00 AM", isAvailable: false },
            { time: "11:30 AM", isAvailable: true },
          ],
          afternoon: [
            { time: "10:30 AM", isAvailable: true },
            { time: "1:00 AM", isAvailable: false },
            { time: "2:30 AM", isAvailable: true },
          ],
          evening: [
            { time: "6:30 AM", isAvailable: false },
            { time: "7:00 AM", isAvailable: false },
            { time: "8:30 AM", isAvailable: true },
          ],
        },
        {
          morning: [
            { time: "10:30 AM", isAvailable: true },
            { time: "11:00 AM", isAvailable: false },
            { time: "11:30 AM", isAvailable: true },
          ],
          afternoon: [
            { time: "10:30 AM", isAvailable: true },
            { time: "1:00 AM", isAvailable: false },
            { time: "2:30 AM", isAvailable: true },
          ],
          evening: [
            { time: "6:30 AM", isAvailable: false },
            { time: "7:00 AM", isAvailable: false },
            { time: "8:30 AM", isAvailable: true },
          ],
        },
        {
          morning: [
            { time: "10:30 AM", isAvailable: true },
            { time: "11:00 AM", isAvailable: false },
            { time: "11:30 AM", isAvailable: true },
          ],
          afternoon: [
            { time: "10:30 AM", isAvailable: true },
            { time: "1:00 AM", isAvailable: false },
            { time: "2:30 AM", isAvailable: true },
          ],
          evening: [
            { time: "6:30 AM", isAvailable: false },
            { time: "7:00 AM", isAvailable: false },
            { time: "8:30 AM", isAvailable: true },
          ],
        },
        {
          morning: [
            { time: "10:30 AM", isAvailable: true },
            { time: "11:00 AM", isAvailable: false },
            { time: "11:30 AM", isAvailable: true },
          ],
          afternoon: [
            { time: "10:30 AM", isAvailable: true },
            { time: "1:00 AM", isAvailable: false },
            { time: "2:30 AM", isAvailable: true },
          ],
          evening: [
            { time: "6:30 AM", isAvailable: false },
            { time: "7:00 AM", isAvailable: false },
            { time: "8:30 AM", isAvailable: true },
          ],
        },
        {
          morning: [
            { time: "10:30 AM", isAvailable: true },
            { time: "11:00 AM", isAvailable: false },
            { time: "11:30 AM", isAvailable: true },
          ],
          afternoon: [
            { time: "10:30 AM", isAvailable: true },
            { time: "1:00 AM", isAvailable: false },
            { time: "2:30 AM", isAvailable: true },
          ],
          evening: [
            { time: "6:30 AM", isAvailable: false },
            { time: "7:00 AM", isAvailable: false },
            { time: "8:30 AM", isAvailable: true },
          ],
        },
        {
          morning: [
            { time: "10:30 AM", isAvailable: true },
            { time: "11:00 AM", isAvailable: false },
            { time: "11:30 AM", isAvailable: true },
          ],
          afternoon: [
            { time: "10:30 AM", isAvailable: true },
            { time: "1:00 AM", isAvailable: false },
            { time: "2:30 AM", isAvailable: true },
          ],
          evening: [
            { time: "6:30 AM", isAvailable: false },
            { time: "7:00 AM", isAvailable: false },
            { time: "8:30 AM", isAvailable: true },
          ],
        },
        {
          morning: [
            { time: "10:30 AM", isAvailable: true },
            { time: "11:00 AM", isAvailable: false },
            { time: "11:30 AM", isAvailable: true },
          ],
          afternoon: [
            { time: "10:30 AM", isAvailable: true },
            { time: "1:00 AM", isAvailable: false },
            { time: "2:30 AM", isAvailable: true },
          ],
          evening: [
            { time: "6:30 AM", isAvailable: false },
            { time: "7:00 AM", isAvailable: false },
            { time: "8:30 AM", isAvailable: true },
          ],
        },
      ],
    },
  ];
  return (
    <section className="py-3">
      <div className="container px-lg-3 px-0">
        <div className="w-85 bg-white shadow rounded_outer mx-auto">
          <div className="pb-3 pt-3">
            <div className="container px-0">
              {cards.map((el, i) => (
                <Card key={i} {...el} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DoctorList;
